import {useContext} from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { AuthContext } from '../Auth/context/AuthContext'

export const NavBarAdmin = () => {

  const navigate = useNavigate();

  const { user, logout } = useContext(AuthContext);

  const onLogout = () => {
    
    logout();

    navigate(('/public/home'), { replace: true });  
  }

  return (
    <nav className="navbar navbar-expand-md navbar-dark bg-dark sticky-top py-1" aria-label="Fourth navbar example">
      <div className="container-fluid">
        <NavLink className="navbar-brand mx-3 me-3" to="/">ICIAR</NavLink>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample04" aria-controls="navbarsExample04" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarsExample04">
          <ul className="navbar-nav me-auto mb-2 mb-md-0 mx-3 gap-4">
            
            {/**Semestre Actual */}
            <li className="nav-item dropdown">
              <NavLink className="nav-link dropdown-toggle" to="/" id="dropdown04" data-bs-toggle="dropdown" aria-expanded="false">Semestre Actual</NavLink>
              <ul className="dropdown-menu p-3" aria-labelledby="dropdown04">
                <li><NavLink className="dropdown-item" to="/">Calificaciones Parciales</NavLink></li>
                <li><NavLink className="dropdown-item" to="/">Calificaciones finales</NavLink></li>
                <li><NavLink className="dropdown-item" to="/">Mi horario de clases</NavLink></li>
                <li><NavLink className="dropdown-item" to="/">Evaluación a instructores</NavLink></li>
              </ul>
            </li>

            {/**Datos Generales */}
            <li className="nav-item dropdown">
              <NavLink className="nav-link dropdown-toggle" to="/" id="dropdown04" data-bs-toggle="dropdown" aria-expanded="false">Datos Generales</NavLink>
              <ul className="dropdown-menu p-3" aria-labelledby="dropdown04">
                <li><NavLink className="dropdown-item" to="/">Mi carrera</NavLink></li>
                <li><NavLink className="dropdown-item" to="/">Mi kardex</NavLink></li>
                <li><NavLink className="dropdown-item" to="/">Servicio Social</NavLink></li>
                <li><NavLink className="dropdown-item" to="/">Reticula</NavLink></li>
              </ul>
            </li>

            {/* Reincripción */}
            <li className="nav-item dropdown">
              <NavLink className="nav-link dropdown-toggle" to="/" id="dropdown04" data-bs-toggle="dropdown" aria-expanded="false">Reincripción</NavLink>
              <ul className="dropdown-menu p-3" aria-labelledby="dropdown04">
                <li><NavLink className="dropdown-item" to="/">Fecha de Reincripción</NavLink></li>
                <li><NavLink className="dropdown-item" to="/">Realizar Reincripción</NavLink></li>
                <li><NavLink className="dropdown-item" to="/">Pagos</NavLink></li>
              </ul>
            </li>

          </ul>
          <div className="btn-group me-5 pe-5">
            <button type="button" className="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              {user.name}
            </button>
            <ul className="dropdown-menu p-3">
              <li><NavLink className="dropdown-item" to="/">Perfil</NavLink></li>
              <li><NavLink className="dropdown-item" to="/">Configuración</NavLink></li>
              <li><hr className="dropdown-divider"/></li>
              <li><button className="dropdown-item" onClick={onLogout}>Salir</button></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}
